import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { useNavigate, useLocation } from "react-router-dom";
import { getDepositWithdrawalsDetails, getUserDetails } from "../../api/apiHandler";
import { showMessage, showErrorMessage, convertUTCToLocal } from "../common/Utils";
import $ from 'jquery';
import 'magnific-popup';
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import 'select2';
import 'select2/dist/css/select2.min.css';
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";

export function DepositWithdrawalDetails() {

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#B6A878',
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '14px',
                textAlign: 'center',
                padding: '10px',
            },
        },
        cells: {
            style: {
                padding: '8px',
                textAlign: 'center',
                borderBottom: '1px solid #e0e0e0',
            },
        },
    };

    const location = useLocation();
    const extracted = location.pathname.split('/');
    let customer_id = atob(extracted[3]);
    let navigate = useNavigate();
    const selectRef = useRef(null);
    const initialized = useRef(false); // Prevents multiple initializations
    const timezone = localStorage.getItem('timezone');

    const titleStyle = { background: 'linear-gradient(180deg, #D7C9A1, #D7C9A1)', padding: '5px 20px', borderRadius: '20px' };
    const boxStyle = { border: '2px solid #D7C9A1', padding: '5px 20px', borderRadius: '20px' };

    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [pagination, setPagination] = useState({ page: 1, perPage: 50 });
    const [sortField, setSortField] = useState("id");
    const [sortOrder, setSortOrder] = useState("DESC");
    const [filters, setFilters] = useState({ title: 'all' });
    const [userprofile, setUserProfile] = useState(null);

    // Fetch data from server
    const fetchUserProfile = async () => {
        try {
            
            const userReq = {
                user_id: customer_id
            }
            
            const response = await getUserDetails(userReq);
            if (parseInt(response.code) === 1) {
                setUserProfile(response.data);
            } else {
                showErrorMessage(response.message);
            }
        } catch (error) {
            showErrorMessage("Something went wrong loading user details, please try again later");
        }
    };

    // Fetch data from server
    const fetchData = async () => {
        setLoading(true);
        try {
            const userReq = {
                user_id: customer_id,
                page: pagination.page,
                per_page: pagination.perPage,
                search,
                sort: sortField,
                order: sortOrder,
                status: filters.title
            };
            const response = await getDepositWithdrawalsDetails(userReq);
            if (parseInt(response.code) === 1) {
                setData(response.data.items);
                setTotalRows(response.data.totalcount);
            } else {
                showErrorMessage(response.message);
            }
        } catch (error) {
            showErrorMessage("Something went wrong loading user's deposit/withdrawals, please try again later");
        }
        setLoading(false);
    };

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            $(selectRef.current).select2();
            $('.image-popup').magnificPopup({
                type: 'image',
                gallery: { enabled: true }
            });
        }
        
        fetchUserProfile();
        fetchData();  // ✅ Ensure fetching happens when dependencies change
    }, [pagination, search, sortField, sortOrder]);
    
    useEffect(() => {
        if (!initialized.current) return;
    
        $(selectRef.current).val(filters.title).trigger('change');
    
        const handleChange = function () {
            const value = $(this).val();
            console.log("value : ", value, "filters.title (before update): ", filters.title);
            // if (value !== filters.title) {
            //     setFilters({ title: value }); // ✅ This is asynchronous
            // }
            setFilters(prevFilters => {
                if (prevFilters.title !== value) {
                    console.log("Updating filters to:", value);
                    return { title: value };
                }
                return prevFilters; // No update if the value is the same
            });        
        };
    
        $(selectRef.current).on("change", handleChange);
    
        return () => {
            $(selectRef.current).off("change", handleChange);
        };
    }, []);

    // ✅ Trigger `fetchData()` when `filters` change
    useEffect(() => {
        console.log("Updated filters:", filters);
        fetchData(filters); // Fetch data after filters update
    }, [filters]);

    // Handle pagination
    const handlePageChange = (page) => {
        setPagination((prev) => ({ ...prev, page }));
    };
    
    const handlePerRowsChange = (perPage) => {
        setPagination({ page: 1, perPage });
    };
    
      // Handle sorting
    const handleSort = (column, sortDirection) => {
        setSortField(column.sortableField); // Field to sort by
        setSortOrder(sortDirection.toUpperCase()); // ASC or DESC
    };

    const formatNumber = (num) => {
        if (!num) return "0";

        const parsed = parseFloat(num);
        return parsed % 1 === 0 
            ? parsed.toFixed(0) 
            : parsed.toFixed(2).replace(/\.?0+$/, "");
    };

    const handleGoBack = () => {
        navigate(-1);
    };
    
    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Users Deposit/Withdrawals</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                    <i className="zmdi zmdi-home" />
                                        Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/deposit-withdrawal/listing">
                                        Deposit/Withdrawals
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Users Deposit/Withdrawals</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="card member-card">
                                <div className="header l-red">
                                    <div className="col-12 text-left">
                                        <a
                                            href="#"
                                            onClick={handleGoBack}
                                            className="btn btn-raised bg-primary waves-effect waves-red text-left"
                                        >
                                            <i className="zmdi zmdi-arrow-left" />
                                        </a>
                                    </div>
                                </div>
                                <div className="bg-custom bg-profile  button-color-css">
                                    <div className="member-img m-t-5">
                                        <img
                                        src={ userprofile ? userprofile.profile_image : '' }
                                        className="rounded-circle"
                                        alt="image"
                                        width="{100}"
                                        height="150px" />
                                    </div>
                                    <div className="body">
                                        <div className="col-12">
                                            <ul className="list-inline">
                                                <li>
                                                    <h4 className="m-t-5">{userprofile ? userprofile.first_name : ''} { userprofile ? userprofile.last_name : '' }</h4>
                                                </li>
                                            </ul>
                                        </div>
                                        <hr />
                                        <div className="card">
                                            <div className="row text-left">
                                                <div className="col-md-6">
                                                    <div className="card">
                                                        <h4 className="" style={ titleStyle }>
                                                            <b>WALLET BALANCE : {userprofile ? userprofile.balance : ''} ({userprofile ? userprofile.currency_code : ''})</b>
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <h4 className="mb-2" style={ titleStyle }>
                                                        <b>AVAILABLE BALANCE : {userprofile ? userprofile.available_balance : ''} ({userprofile ? userprofile.currency_code : ''})</b>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <h4 className="mt-1" style={ titleStyle }><center>ALL TRANSACTION</center></h4>
                                <div className="body">
                                    <div className="table-responsive">
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <div style={{ position: "relative", maxWidth: "300px" }}>
                                                <div className="col-md-3 col-lg-3 col-xl-3">
                                                    <div className="form-group">
                                                        <select ref={selectRef} className="form-control" id="title" name="title" style={{ minWidth: '200px' }}>
                                                            <option value="all">All</option>
                                                            <option value="addmoney_wallet_title">Deposits</option>
                                                            <option value="debitmoney_wallet_title">Withdrawals</option>
                                                            <option value="commission">Commission</option>
                                                            <option value="financing">Financing</option>
                                                            <option value="settlement">Settlement</option>
                                                            <option value="cost">Service Fee</option>
                                                            <option value="ex_dividend">Dividend</option>
                                                            <option value="rebate">Rebate</option>
                                                            <option value="negative_balance_correction">Balance</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ position: "relative", maxWidth: "300px" }}>
                                                <input
                                                    type="text"
                                                    placeholder="🔍 Search..."
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        padding: "10px 15px",
                                                        borderRadius: "25px",
                                                        border: "1px solid #ccc",
                                                        outline: "none",
                                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                        fontSize: "14px",
                                                    }}
                                                    className="form-control mb-3"
                                                />
                                            </div>
                                        </div>
                                        <DataTable
                                            columns={[
                                                { name: "TYPE", selector: (row) => (row.status === 'credit') ? <label className="label label-success">Credit</label> : <label className="label label-danger">Debit</label>, sortable: false, width: '10%' },
                                                { name: "TXN-TYPE", selector: (row) => {
                                                    if (row.og_title === 'debitmoney_wallet_title') {
                                                        return <label className="label label-black">Withdraw</label>
                                                    } else if (row.og_title === 'addmoney_wallet_title') {
                                                        return <label className="label label-black">Deposit</label>
                                                    } else if (row.og_title === 'commission') {
                                                        return <label className="label label-black">Commission</label>
                                                    } else if (row.og_title === 'financing') {
                                                        return <label className="label label-black">Financing</label>
                                                    } else if (row.og_title === 'settlement') {
                                                        return <label className="label label-black">Settlement</label>
                                                    } else if (row.og_title === 'cost') {
                                                        return <label className="label label-black">Service Fee</label>
                                                    } else if (row.og_title === 'ex_dividend') {
                                                        return <label className="label label-black">Dividend</label>
                                                    } else if (row.og_title === 'rebate') {
                                                        return <label className="label label-black">Rebate</label>
                                                    } else if (row.og_title === 'negative_balance_correction') {
                                                        return <label className="label label-black">Balance Correction</label>
                                                    } else {
                                                        return <label className="label label-black">{row.title}</label>
                                                    }
                                                }, sortable: false, width: '15%' },
                                                { name: "AMOUNT", selector: (row) => `${formatNumber(row.amount)} ${row.currency}`, sortable: false, width: '10%' },
                                                { name: "TXN-ID", selector: (row) => row.transaction_id ? row.transaction_id : 'NA', sortable: false, width: '12%' },
                                                { name: "PAID VIA", selector: (row) => <label className="label label-warning">{row.payment_mode}</label>, sortable: false, width: '12%' },
                                                { name: "PAYMENT STATUS", selector: (row) => {
                                                    if (row.payment_status === 'Pending') {
                                                        return <label className="label label-warning">Pending</label>
                                                    } else if (row.payment_status === 'Approved') {
                                                        return <label className="label label-success">Approved</label>
                                                    } else {
                                                        return <label className="label label-danger">${row.payment_status}</label>
                                                    }
                                                }, sortable: false, width: '12%' },
                                                { name: "DESCRIPTION", selector: (row) => row.title, sortable: false, width: '15%' },
                                                { name: "CREATED AT", selector: (row) => convertUTCToLocal(row.created_at, timezone), sortable: true, sortableField: "created_at", width: '15%' },
                                            ]}
                                            data={data || []}
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                            paginationPerPage={50} // Default page size
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            onSort={handleSort}
                                            sortServer
                                            persistTableHead
                                            progressPending={loading}
                                            customStyles={customStyles}
                                            noDataComponent={<div style={{ textAlign: "center", padding: "20px", color: "#888" }}>No data found</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}